import {Component, Injector, Input} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {MembershipTypeSearchModel} from "../membership-type-search.model";
import {MembershipTypeSearchPageComponent} from "../membership-type-search-page/membership-type-search-page.component";
import {MembershipTypeEditPageComponent} from "../membership-type-edit-page/membership-type-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";

@Component({
    selector: "wbo-membership-type-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(MembershipTypeSingleSelectEditControlComponent),
        provideSearchModel(MembershipTypeSearchModel)
    ]
})
export class MembershipTypeSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<MembershipTypeSearchModel> {
    @Input() includeGuestOption: boolean = false;

    constructor(model: MembershipTypeSearchModel, injector: Injector) {
        super(model, injector, "membershipTypeId", "name");

        this.extendedSearchComponent = MembershipTypeSearchPageComponent;
        this.extendedEditComponent = MembershipTypeEditPageComponent;
    }

    override onDataLoaded(data: Array<any>): void {
        if (this.includeGuestOption) {
            data.unshift({
                [this.labelField]: this.translateService.instant("wbo.membership-type.option.guest"),
                [this.valueField]: MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE
            });
        }
    }

    override onOptionOpen(option: any): void {
        if (option[this.valueField] !== MembershipTypeSearchModel.GUEST_MEMBERSHIP_TYPE) {
            this.selectControlComponent.openView(option);
        }
    }
}
